export default {
  setPrecos(state, payload) {
    state.precos = payload;
  },
};
